import React from "react";

import { isArray } from "@dvrt/react-tools";
import { FormattedMessage } from "react-intl";
import DisabledDeleteResourceButton from "./DisabledDeleteResourceButton";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

function getUserContextCol(contexts, role) {
    let contextsToShow = [];

    for (let userContext of contexts) {
        for (let roleContext of role["role_contexts"]) {
            if (userContext.context.id == roleContext.context.id && roleContext["predefined_value"] == null) {
                contextsToShow.push(userContext);
                break;
            }
        }
    }

    if (contextsToShow.length == 1) {
        let context = contextsToShow[0];
        let rows = [];
        for (let key in context["context_data"]) {
            let val = context["context_data"][key];
            rows.push(
                <div>
                    <FormattedMessage id={key} />: <span>{isArray(val) ? val.join(", ") : val}</span>
                </div>,
            );
        }
        return <div>{...rows}</div>;
    }
    // TODO: more than 1...

    return null;
}

type UserRoleSummaryProps = {
    userGrants: any[];
    userSubId: number;
    onUpdateRole?: (changed: boolean) => void;
};

const UserRoleSummary: React.FC<UserRoleSummaryProps> = ({ userGrants, userSubId }) => {
    userGrants.sort((a, b) => {
        if (a.id > b.id) return -1;
        if (a.id < b.id) return 1;
        return 0;
    });
    let rows = [];
    userGrants.forEach((grant, index) => {
        rows.push(
            <TableRow key={index}>
                <TableCell>{grant.role.client["display_name"]}</TableCell>
                <TableCell>{grant.role.name}</TableCell>
                <TableCell>{getUserContextCol(grant["user_contexts"], grant.role)}</TableCell>
                <TableCell>
                    <DisabledDeleteResourceButton
                        resourceName="user_grant"
                        id={grant.id}
                        userId={userSubId}
                        translationKey="deleting_own_user_role_is_forbidden"
                    />
                </TableCell>
            </TableRow>,
        );
    });

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <FormattedMessage id="role.client" />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage id="user_roles.role" />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage id="role.contexts" />
                    </TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>{...rows}</TableBody>
        </Table>
    );
};

export default UserRoleSummary;
